// extracted by mini-css-extract-plugin
export default {"link":"HelpLink_link__pONS4","linkIconWrapper":"HelpLink_linkIconWrapper__Yclop","docIconWrapper":"HelpLink_docIconWrapper__WnA2I","text":"HelpLink_text__tCUXx"};